import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { FaFacebook, FaTwitter, FaInstagram, FaLinkedin } from 'react-icons/fa';

const Footer = () => {
  return (
    <footer className="bg-dark text-white py-4 mt-5">
      <Container>
        <Row>
          <Col md={4} className="mb-4 mb-md-0">
            <h5>UKSecondhand</h5>
            <p className="text-muted">
              Your trusted marketplace for buying and selling second-hand vehicles.
            </p>
            <div className="d-flex">
              <a href="#" className="social-icon"><FaFacebook /></a>
              <a href="#" className="social-icon"><FaTwitter /></a>
              <a href="#" className="social-icon"><FaInstagram /></a>
              <a href="#" className="social-icon"><FaLinkedin /></a>
            </div>
          </Col>
          <Col md={2} className="mb-4 mb-md-0">
            <h5>Quick Links</h5>
            <ul className="list-unstyled">
              <li><a href="#" className="text-primary text-decoration-none">Home</a></li>
              <li><a href="#" className="text-primary text-decoration-none">Vehicles</a></li>
              <li><a href="#" className="text-primary text-decoration-none">Sell</a></li>
              <li><a href="#" className="text-primary text-decoration-none">About Us</a></li>
            </ul>
          </Col>
          <Col md={3} className="mb-4 mb-md-0">
            <h5>Customer Service</h5>
            <ul className="list-unstyled">
              <li><a href="#" className="text-primary text-decoration-none">Contact Us</a></li>
              <li><a href="#" className="text-primary text-decoration-none">FAQs</a></li>
              <li><a href="#" className="text-primary text-decoration-none">Shipping Policy</a></li>
              <li><a href="#" className="text-primary text-decoration-none">Returns</a></li>
            </ul>
          </Col>
          <Col md={3}>
            <h5>Newsletter</h5>
            <p className="text-muted">Subscribe to get updates on new arrivals and special offers.</p>
            <div className="d-flex">
              <input type="email" className="form-control" placeholder="Your email" />
              <button className="btn btn-primary ms-2">Subscribe</button>
            </div>
          </Col>
        </Row>
        <hr className="my-4" />
        <Row>
          <Col className="text-center text-muted">
            <small>&copy; {new Date().getFullYear()} UKSecondhand. All rights reserved.</small>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;